<!-- 

	Was macht diese Componente?
	Wofür ist die Compoente da?
	
	Welche $props gibt es?
	
	Beispiel Code:
		<Dummy></Dummy>
	
	2019-06-08	init

-->

<template>
	<div class="Sidebar background background--white sticky" :class="elmClasses">		
		<div class="Sidebar__inner">
			
			<!-- header mit logo -->
			<div class="Sidebar__header hSpace hSpace--medium">
				<div class="Sidebar__headerLink block">
					Baden-Württemberg<br />
					Landesamt für Denkmalpflege
					<span class="Sidebar__headerLogo block"></span>
				</div>
				<!--
				<router-link class="Sidebar__headerLink block" :to="'/'">
					Baden-Württemberg<br />
					Landesamt für Denkmalpflege
					<span class="Sidebar__headerLogo block"></span>
				</router-link>
				-->
				<div class="Sidebar__hr background background--middleGrey"></div>				
			</div>
			
			<!-- body mit contextbased content -->
			<div class="Sidebar__body hSpace hSpace--medium">
				
				<!--
				<pre name="app.doc.isValid" v-if="app.doc">{{app.doc.isValid}}</pre>
				<pre name="app.doc.countDatasets()" v-if="app.doc">{{app.doc.countDatasets()}}</pre>
				<pre name="app.doc.countInvalidDatasets()" v-if="app.doc">{{app.doc.countInvalidDatasets()}}</pre>
				<pre name="$route.name">{{$route.name}}</pre>
				-->
				
				<!-- progressBar für validierungs status -->
				<template v-if="app.doc && !app.doc.isValid && $route.name == 'EditView'">
					<div class="Sidebar__progress vSpace vSpace--medium" v-if="app.doc">
						<div class="Sidebar__progressText">
							<div class="color color--grey">Zu bearbeitende Felder</div>
							<div class="color font XXfont--bold font--sizeBig"
								 :class="{
									 'color--darkRed'   : !app.doc.isValid,
									 'color--darkGreen' : app.doc.isValid,
								 }">
								{{app.doc.countInvalidDatasets}}
							</div>
						</div>
						<div class="Sidebar__progressBar">
							<div class="Sidebar__progressBarDone"></div>
							<div class="Sidebar__progressBarTodo" :style="progressBarTodoStyles"></div>
						</div>
					</div>
				</template>
				<!-- download buttons -->
				<template v-if="app.doc && app.doc.isValid && $route.name == 'EditView'">
					<div class="Sidebar__download vSpace vSpace--medium">
						<div class="Sidebar__downloadText">
							<div class="color color--darkGreen font font--bold">Download</div>
							<div class="color XXcolor--darkGreen font font--sizeSmall">
								<br/>
								Es wurden alle Felder erfolgreich korrigiert.
								Die Daten können nun heruntergeladen werden.
								<br/>
								<br/>
							</div>
							<BaseButton
								class="BaseButton--downloadBtn Sidebar__downloadBtn"
								tag="a"
								label="Download als CSV Tabelle"
								@click.native="app.doc.downloadAsCsv()"
							></BaseButton>
						</div>					
					</div>
				</template>

				<!-- Link zu Modal "Tabellenansicht" -->
				<template v-if="1==2">
					<div class="Sidebar__hr background background--middleGrey"></div>				
					<br />
					<a @click="app.showTableModal = true">Tabellenansicht</a>
				</template>

				<!--
				<hr/>
				<a @click="app.doc.downloadAsCsv()">downloadAsCsv</a>
				<hr/>
				<pre name="app.doc.isValid">{{app.doc ? app.doc.isValid : undefined}}</pre>
				<hr/>
				-->
				
			</div>
			
			<!-- Footer mit Hilfe- und Impressums-Links -->
			<div class="Sidebar__footer hSpace hSpace--medium">				
				<div class="Sidebar__hr background background--middleGrey"></div>
				<div class="Sidebar__footerInner">
					<a class="Sidebar__footerLink" @click="app.showImprintModal = true">Impressum</a>
				</div>
			</div>
		
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import { EventBus } from '@/event-bus.js'
	//import BaseButton from '@/components/MhForm/BaseButton.vue'
	import BaseButton from '@/components/MhForm/v1/BaseButton.vue'
	
	export default {
		name: 'Sidebar',
		components: {
			BaseButton,
		},
		mixins: [],
		props: {},
		data() {
			return {}
		},
		watch: {},
		computed: {
			app() {
				return this.$root.$children[0]
			},
			elmClasses(){
				let classes = []
				
				//classes.push('new_class')
				
				return classes
			},
			progressBarTodoStyles(){
				let styles = {}
				
				const width = (this.app.doc.countInvalidDatasets / this.app.doc.datasets.length ) * 100
				
				if( this._.isNumber( width ) ) styles.width = width + '%'
				
				return styles
			}
		},
		methods: {},
		created() {},
		mounted() {},
		destroyed () {},
	}
</script>

<style lang="less">
	@import "../less/vars.less";
	@import (reference) "../less/mixins.less";
	@import (reference) "../less/atoms.less";
	
	.Sidebar {
		.relative;
		//.outline( red );
		
		max-height: 100vh;		
		max-width: 100%;
		min-width: 0;
		box-shadow: 0 0 1em 0.5em fade(black, 10);
	}
	.Sidebar__inner {
		//& > * { outline: 1px solid red; }
		
		display: flex;
		flex-direction: column;
		height: 100vh;
	}
	.Sidebar__header {
		position: relative;
		flex-shrink: 0;
		
		&Link {
			//outline: 1px solid red;
			position: relative;
			padding-bottom: 25%;
			color: transparent;
			margin: 2em 0;
			//cursor: pointer;
		}
		&Logo {
			position: absolute;
			top: 0; left: 0; right: 0; bottom: 0;
			background-image: url('../assets/images/logo.png');
			background-repeat: no-repeat;
			background-position: top center;
			background-size: contain;
		}
	}
	.Sidebar__body {
		flex-grow: 1;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.Sidebar__footer {
		position: relative;
		flex-shrink: 0;
		
		&Inner {
			display: flex;
			justify-content: center;			
		}
		
		&Link {
			padding: 1.5em 1em;
			color: inherit;
			text-decoration: none;
			transition: all 0.1s ease;
			opacity: 0.5;
		}
		&Link:hover {
			opacity: 0.85;
		}
	}
	.Sidebar__hr {
		height: 1px;
	}
	
	.Sidebar__downloadBtn {
		margin-bottom: 0.5em;
	}
	
	.Sidebar__debug {
		[showBorders1] & { display: block; }
		display: none;
		background-color: fade( yellow, 50 );
		padding: 0.5em;
		margin-top: 1em;
	}
	
	.Sidebar__progress {
		&Text {
			display: flex;
			justify-content: space-between;
			padding-bottom: 0.5em;
		}
		
		&Bar {
			display: flex;
			height: 0.8em;
			border-radius: 0.3em;
			overflow: hidden;
			background-color: fade( @swatches[darkRed], 70 );
		}
		&BarDone {
			height: inherit;
			flex-grow: 1;
			
			transition: all 0.1s ease;
			border: 1px solid @swatches[green];
			border-top-left-radius: inherit;
			border-bottom-left-radius: inherit;
			border-top-right-radius: inherit;
			border-bottom-right-radius: inherit;
			background-color: @swatches[lightGreen];
		}
		&BarTodo {
			height: inherit;
			
			transition: all 0.1s ease;
			/*
			border: 1px solid @swatches[red];			
			margin-right: -3px;
			border-top-right-radius: inherit;
			border-bottom-right-radius: inherit;
			background-color: @swatches[lightRed];
			*/
		}
	}
	.Sidebar__selectedScheme {
		&Text {
			display: flex;
			justify-content: space-between;
			padding-bottom: 0.5em;
		}
	}
	.Sidebar__filters {
		&Text {
			display: flex;
			justify-content: space-between;
			padding-bottom: 0.5em;
			align-items: flex-start;
			//line-height: 1em;
		}
		
		&InputWrapper {
			display: block;			
		}
	}
	
	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
